import { h } from 'preact';

export const ErrorIcon = () => {
	return (
		<svg fill="none" width={16} height={16} viewBox="0 0 16 16">
			<path fill="var(--error-secondary)"
			      d="M8 .25a7.75 7.75 0 100 15.5A7.75 7.75 0 008 .25zM8 12a1 1 0 110-2 1 1 0 010 2zm1.2-7.45l-.4 4a.5.5 0 01-.5.45h-.6a.5.5 0 01-.5-.45l-.4-4A.5.5 0 017.3 4h1.4a.5.5 0 01.5.55z"
			      opacity=".4"/>
			<path fill="var(--error-secondary)"
			      d="M8.7 4H7.3a.5.5 0 00-.5.55l.4 4a.5.5 0 00.5.45h.6a.5.5 0 00.5-.45l.4-4A.5.5 0 008.7 4zM8 10a1 1 0 100 2 1 1 0 000-2z"/>
		</svg>
	);
};
